import React from 'react';
import { Box } from '@mui/material';

interface CustomEmojiProps {
  emoji: string;
  size?: number;
  style?: React.CSSProperties;
}

const CustomEmoji: React.FC<CustomEmojiProps> = ({ emoji, size = 20, style }) => {
  // Define custom emoji mappings
  const customEmojis: { [key: string]: string } = {
    '❤️': '/heart-emoji.png', // Custom heart emoji
    'heart': '/heart-emoji.png', // Alternative key for heart
  };

  const isCustomEmoji = customEmojis[emoji];
  
  if (isCustomEmoji) {
    return (
      <Box
        component="img"
        src={isCustomEmoji}
        alt={emoji}
        sx={{
          width: size,
          height: size,
          objectFit: 'contain',
          display: 'inline-block',
          verticalAlign: 'middle',
          ...style
        }}
      />
    );
  }

  // Render Unicode emoji
  return (
    <Box
      component="span"
      sx={{
        fontSize: size,
        lineHeight: 1,
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style
      }}
    >
      {emoji}
    </Box>
  );
};

export default CustomEmoji; 